import {use} from 'react'

import {DragAndDropItemContext} from '../context/DragAndDropItemContext'

export const useDragAndDropItem = () => {
  const context = use(DragAndDropItemContext)
  if (!context) {
    throw new Error('useDragAndDropItem must be used within a DragAndDropItemContextProvider')
  }
  return context
}
